/* Category/model suggestions reuse the theme's keyboard-capable predictive UI. */
(function () {
  'use strict';
  const root = document.querySelector('[data-parts-shell]');
  if (!root || !window.EsvPartsVehicle) return;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  let images = {};
  try { images = JSON.parse(root.querySelector('[data-parts-images]').textContent); } catch (_) { /* Optional illustrations. */ }
  customElements.whenDefined('predictive-search').then(() => {
    document.querySelectorAll('.esv-parts-header predictive-search').forEach(search => {
      const native = search.getSearchResults.bind(search);
      document.addEventListener('esv:vehicle-change', () => {
        search.close();
        search.removeAttribute('results');
      });
      search.input.addEventListener('keydown', event => { if (event.key === 'Escape') search.close(); });
      const mobile = matchMedia('(max-width: 989px)');
      const placeholder = () => { search.input.placeholder = mobile.matches ? 'Teil, Modell, Artikelnummer' : 'Teil, Scooter-Modell oder Artikelnummer suchen'; };
      placeholder(); mobile.addEventListener('change', placeholder);
      search.getSearchResults = async query => {
        if (!search.contains(document.activeElement)) return;
        const version = ++search.requestVersion;
        search.requestController?.abort();
        const current = () => version === search.requestVersion && search.getQuery() === query && search.contains(document.activeElement);
        search.setLiveRegionLoadingState();
        let rows;
        try {
          const { groups, vehicles } = await window.EsvPartsVehicle.load();
          rows = window.EsvPartsCatalog.suggestions(query, groups, vehicles);
        } catch (_) { if (current()) return native(query); return; }
        if (!current()) return;
        if (!rows.length) return native(query);
        const html = rows.map((row, i) => {
          const path = row.kind === 'vehicle' ? root.dataset.searchUrl : '/collections/' + row.handle;
          const target = new URL(window.EsvPartsVehicle.url(path, row.vehicle || window.EsvPartsVehicle.get()));
          if (row.query) target.searchParams.set('q', row.query);
          const raw = images[row.handle];
          const image = raw ? new URL(raw, location.origin) : null;
          const photo = image && image.protocol === 'https:' ? `<img src="${escape(image.href)}" alt="" width="48" height="48">` : '';
          return `<li id="esv-predictive-${i}" role="option" aria-selected="false"><a class="esv-search-suggestion" href="${escape(target.href)}" tabindex="-1">${photo}<span><strong>${escape(row.label)}</strong><small>${row.kind === 'vehicle' ? 'Scooter auswählen' : row.kind === 'category' ? 'Kategorie öffnen' : 'Passende Teile finden'}</small></span></a></li>`;
        }).join('');
        search.setLiveRegionLoadingState();
        search.renderSearchResults(`<div id="predictive-search-results"><h3 class="esv-suggestions-heading">Kategorien &amp; Scooter</h3><ul id="predictive-search-results-list" role="listbox" class="esv-search-suggestions">${html}</ul><span class="visually-hidden" data-predictive-search-live-region-count-value>${rows.length} Vorschläge</span></div>`);
      };
    });
  });
})();
